import { useEffect, useState } from "react";
import moment from "moment";

// Returns a moment that refreshes on an interval so components re-render and any
// elapsed-time computations advance. 30s is enough for a minute-granular display while
// keeping the visible tick close to each minute boundary. The interval is cleared on unmount.
export default function useNow(intervalMs = 30000) {
  const [now, setNow] = useState(() => moment());
  useEffect(() => {
    const t = setInterval(() => setNow(moment()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}
